var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v("\n            " + _vm._s(_vm.__t("USE_BOTS")) + "\n        "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _c("b-form-radio-group", {
            attrs: {
              id: "btn-radios-1",
              "button-variant": "outline-primary",
              options: [
                { text: _vm.__t("YES"), value: true },
                { text: _vm.__t("NO"), value: false },
              ],
              name: "radios-btn-default",
              buttons: "",
            },
            model: {
              value: _vm.use_bot,
              callback: function ($$v) {
                _vm.use_bot = $$v
              },
              expression: "use_bot",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bots" }, [
      _vm.use_bot
        ? _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "advanced_price" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("BOTS")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group flex-nowrap" },
              [
                _c("v-select", {
                  staticClass: "imc_reasons w-50",
                  attrs: {
                    multiple: "",
                    label: "title_bot",
                    reduce: function (bot) {
                      return bot.id
                    },
                    filterable: false,
                    options: _vm.bots,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(option.channel_data.username) +
                                  "\n                            "
                              ),
                              _c("small", [_vm._v(_vm._s(option.channel))]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2126438722
                  ),
                  model: {
                    value: _vm.bot_ids,
                    callback: function ($$v) {
                      _vm.bot_ids = $$v
                    },
                    expression: "bot_ids",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }